import React from 'react';
import { FiSearch } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';
import './DropdownEmpty.scss';
export default function DropdownEmpty({ kind = 'results' }) {
  const { t } = useTranslation();
  return <div className="dropdown-empty-state" role="status">
    <span className="dropdown-empty-state__icon" aria-hidden="true"><FiSearch /></span>
    <strong>{t('dropdownEmpty.' + kind, 'No matching results')}</strong>
    <p>{t('dropdownEmpty.hint', 'Try a different search.')}</p>
  </div>;
}
